import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/Context';
import './Login.css';

const Login = () => {
    const { userLogin, token } = useAuth();
    const [loginData, setLoginData] = useState({ email: '', password: '' });
    const [errors, setErrors] = useState({});
    const [serverError, setServerError] = useState('');
    const { loading } = useSelector(state => state.LoginReducer);
    const emailRefFocus = useRef(null);
    const passwordRefFocus = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (token) {
            navigate('/');
        }
    }, [token, navigate]);

    // Surfaced when a permission/role change force-expired the session, so the
    // user isn't left guessing why they were logged out mid-task.
    useEffect(() => {
        const reason = sessionStorage.getItem('session_end_reason');
        if (reason) {
            setServerError(reason);
            sessionStorage.removeItem('session_end_reason');
        }
    }, []);

    const onchange = (e) => {
        setLoginData({ ...loginData, [e.target.name]: e.target.value })
    }

    const handleLogin = (e) => {
        e.preventDefault();
        setErrors({});
        let customErrors = {};
        if (loginData.email === '') {
            customErrors = { ...customErrors, email: "Please Enter Email" }
            emailRefFocus.current.focus();
        } else if (!/^([a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$)/.test(loginData.email)) {
            customErrors = { ...customErrors, email: "Please Enter Valid Email" }
            emailRefFocus.current.focus();
        } else if (loginData.password === '') {
            customErrors = { ...customErrors, password: "Please Enter Password" }
            passwordRefFocus.current.focus();
        }

        if (Object.keys(customErrors).length > 0) {
            setErrors(customErrors)
            return true
        }

        setServerError('');
        var data = {
            'email': loginData.email,
            'password': loginData.password
        };
        userLogin(data, (msg) => setServerError(msg));
    }

    const bannerImages = [
        'banner-poster-1.jpg',
        'banner-poster-2.jpg',
        'banner-poster-5.jpg',
        'banner-poster-6.jpg',
        'banner-poster-9.jpg'
    ];

    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) => (prevIndex + 1) % bannerImages.length);
        }, 5000); // Change image every 5 seconds

        return () => clearInterval(interval);
    }, [bannerImages.length]);

    return (
        <div className="login-container">
            <div className="login-image-section">
                {bannerImages.map((image, index) => (
                    <div
                        key={index}
                        className={`carousel-slide ${index === currentImageIndex ? 'active' : ''}`}
                        style={{
                            backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/${image})`,
                        }}
                    />
                ))}
                <div className="carousel-overlay">
                    <div className="carousel-content">
                        <h1>Diverse. Dramatic.</h1>
                        <p>Experience the best short dramas.</p>
                    </div>
                </div>
            </div>
            <div className="login-form-section">
                <div className="login-form-wrapper">
                    <h2 className="login-title">Welcome Back</h2>
                    <p className="login-subtitle">Please sign in to your account</p>
                    
                    <form onSubmit={handleLogin} autoComplete='off'>
                        <div className="login-form-group">
                            <input
                                type="email"
                                className="login-input"
                                id="email"
                                name="email"
                                value={loginData.email}
                                onChange={onchange}
                                placeholder=" " 
                            />
                            <label htmlFor="email" className="login-label">Email Address</label>
                            {errors.email && <span className="login-error">{errors.email}</span>}
                        </div>

                        <div className="login-form-group">
                            <input
                                type="password"
                                className="login-input"
                                id="password"
                                name="password"
                                value={loginData.password}
                                onChange={onchange}
                                placeholder=" "
                            />
                            <label htmlFor="password" className="login-label">Password</label>
                            {errors.password && <span className="login-error">{errors.password}</span>}
                        </div>
                        

                        {serverError && (
                            <div className="login-server-error">
                                <span>⚠ {serverError}</span>
                                <button type="button" className="login-server-error-close" onClick={() => setServerError('')}>✕</button>
                            </div>
                        )}
                        
                        <button className="login-btn" type="submit" disabled={loading}>
                            {loading ? <div className="spinner"></div> : "Sign In"}
                        </button>

                    </form>
                </div>
            </div>
        </div>
    );
};
  
export default Login;